export const realtorData = {
  email: 'info@aulenpropiedades.cl',
};
